var ViewHistoryKey = /* @__PURE__ */ ((ViewHistoryKey2) => {
  ViewHistoryKey2["Products"] = "view_history.products";
  return ViewHistoryKey2;
})(ViewHistoryKey || {});
export {
  ViewHistoryKey
};
//# sourceMappingURL=types.js.map
